/**
 * 亚马逊常用类目列表
 * 按照亚马逊官方分类整理
 */

export const AMAZON_CATEGORIES = [
  // 工具和家居改善
  'Tools & Home Improvement',
  'Tools & Home Improvement > Hand Tools',
  'Tools & Home Improvement > Hand Tools > Tool Sets',
  'Tools & Home Improvement > Power & Hand Tools',
  'Tools & Home Improvement > Hardware',
  'Tools & Home Improvement > Building Supplies',
  
  // 家居和厨房
  'Home & Kitchen',
  'Home & Kitchen > Kitchen & Dining',
  'Home & Kitchen > Home Décor',
  'Home & Kitchen > Bedding',
  'Home & Kitchen > Bath',
  'Home & Kitchen > Furniture',
  
  // 电子产品
  'Electronics',
  'Electronics > Computers & Accessories',
  'Electronics > Camera & Photo',
  'Electronics > Headphones',
  'Electronics > TV & Video',
  'Electronics > Cell Phones & Accessories',
  
  // 运动与户外
  'Sports & Outdoors',
  'Sports & Outdoors > Exercise & Fitness',
  'Sports & Outdoors > Outdoor Recreation',
  'Sports & Outdoors > Sports & Fitness',
  
  // 玩具和游戏
  'Toys & Games',
  'Toys & Games > Building Toys',
  'Toys & Games > Dolls & Accessories',
  'Toys & Games > Games',
  
  // 服装鞋靴和珠宝
  'Clothing, Shoes & Jewelry',
  'Clothing, Shoes & Jewelry > Women',
  'Clothing, Shoes & Jewelry > Men',
  'Clothing, Shoes & Jewelry > Girls',
  'Clothing, Shoes & Jewelry > Boys',
  
  // 美容和个人护理
  'Beauty & Personal Care',
  'Beauty & Personal Care > Skin Care',
  'Beauty & Personal Care > Hair Care',
  'Beauty & Personal Care > Makeup',
  
  // 健康和家庭
  'Health & Household',
  'Health & Household > Vitamins & Dietary Supplements',
  'Health & Household > Household Supplies',
  'Health & Household > Medical Supplies & Equipment',
  
  // 宠物用品
  'Pet Supplies',
  'Pet Supplies > Dogs',
  'Pet Supplies > Cats',
  'Pet Supplies > Birds',
  
  // 婴儿用品
  'Baby',
  'Baby > Diapering',
  'Baby > Feeding',
  'Baby > Baby Care',
  
  // 汽车和摩托车
  'Automotive',
  'Automotive > Car Care',
  'Automotive > Exterior Accessories',
  'Automotive > Interior Accessories',
  
  // 办公用品
  'Office Products',
  'Office Products > Office & School Supplies',
  'Office Products > Office Electronics',
  
  // 艺术工艺和缝纫
  'Arts, Crafts & Sewing',
  'Arts, Crafts & Sewing > Craft Supplies',
  'Arts, Crafts & Sewing > Painting, Drawing & Art Supplies',
  
  // 乐器
  'Musical Instruments',
  'Musical Instruments > Guitars & Strings',
  'Musical Instruments > Drums & Percussion',
  
  // 工业和科学
  'Industrial & Scientific',
  'Industrial & Scientific > Professional Dental Supplies',
  'Industrial & Scientific > Lab & Scientific Products',
  
  // 书籍
  'Books',
  
  // 视频游戏
  'Video Games',
  
  // 软件
  'Software',
  
  // 食品杂货和美食
  'Grocery & Gourmet Food',
  
  // 花园和户外
  'Patio, Lawn & Garden',
  'Patio, Lawn & Garden > Gardening & Lawn Care',
  'Patio, Lawn & Garden > Outdoor Power Tools',
].sort();

/**
 * 获取主类目（一级分类）
 */
export const getMainCategories = (): string[] => {
  const mainCategories = new Set<string>();
  AMAZON_CATEGORIES.forEach(category => {
    const main = category.split(' > ')[0];
    mainCategories.add(main);
  });
  return Array.from(mainCategories).sort();
};

/**
 * 根据主类目获取子类目
 */
export const getSubCategories = (mainCategory: string): string[] => {
  return AMAZON_CATEGORIES
    .filter(cat => cat.startsWith(mainCategory + ' >'))
    .sort();
};

